import { render, staticRenderFns } from "./PdpDefaultV1.vue?vue&type=template&id=77e803e8&scoped=true&"
import script from "./PdpDefaultV1.vue?vue&type=script&lang=js&"
export * from "./PdpDefaultV1.vue?vue&type=script&lang=js&"
import style0 from "./PdpDefaultV1.vue?vue&type=style&index=0&id=77e803e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e803e8",
  null
  
)

export default component.exports